import { Grid, Box, Link, Button, Typography, Card } from "@mui/material"
import Header from "../../layout/header"
import data from './mock.json'
import Preview from "./previews/Preview"
import Preview1 from "./previews/Preview1"
import Preview2 from './previews/Preview2'
import Preview3 from "./previews/Preview3"
import Preview4 from './previews/Preview4'
import Preview5 from './previews/Preview5'
import Preview6 from './previews/Preview6'

import { useEffect, useState } from "react"

const Template = () =>{
    const [selectedTemplate, setSelectedTemplate] = useState(localStorage.getItem('template') || 0)
    const [selectedColor, setSelectedColor] = useState(JSON.parse(localStorage.getItem('color')) ||   ['#1B263B', '#D6E0F5','#FFF'])
    let sections = ['Contact', 'Objective', 'Education','Experience', 'Skills', 'Other']
    const colorShades = [
        ['#1B263B', '#D6E0F5','#FFF'], 
        ['#E6E6E6', '#F5F5F5','#000'],
        ['#F5F5DC', '#FFFBEA','#000'],
        ['#033E3E', '#D9E8D6','#FFF'],
        ['#FFC0CB', '#FFE4E6','#FFF'],
        ['#87CEEB', '#E0F3FB','#FFF'],
        ['#FFFFFF', '#FAFAFA','#000'],
        ['#FF6F61', '#FFDDD7','#000'],
        ['#E6E6FA', '#F4F4FF','#FFF'],
        ['#AFE1E1', '#DFF7F7','#000'],
        ['#2C2C2C', '#D3D3D3','#000'],
        ['#6A5ACD', '#DDD8F5','#000'],
        ['#228B22', '#BDE5BD','#000'],
        ['#4682B4', '#CCE5F7','#000'],
        ['#D2B48C', '#EBDDC4','#000'],
        ['#98FF98', '#D9FFDD','#000'],
        ['#96A8A1', '#DDE6E4','#000'],
        ['#800020', '#FFD7D7','#000'],
        ['#8E8E8E', '#DCDCDC','#000'],
    ]

    useEffect(()=>{
        localStorage.setItem('template', selectedTemplate)
    },[selectedTemplate])

    useEffect(()=>{
        localStorage.setItem('color',JSON.stringify(selectedColor))
    },[selectedColor])

    return <>
        <Header />
        <Grid container px={10} pt={5} item xs={12}>
            <Grid item xs={4}>
                <Typography variant="h5">Choose Template</Typography>
            </Grid>
            <Grid item xs={8} sx={{display: 'flex', flexDirection: 'row-reverse'}} gap={3}>
                <Link href={'/create'}><Button variant="contained">Next</Button></Link>
                <Link href={'/'}>
                    <Button variant="outlined">Cancel</Button>
                </Link>
            </Grid>
        </Grid>
       
        <Grid container p={5} xs={12}>
            <Grid container xs={1}>
                <Box py={3} sx={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 10px" }}display={'flex'} flexDirection={'column'} width={'100%'} alignItems={'center'} gap={3}>
                    {colorShades.map((color, index)=>{
                        return <Box key={index} sx={{height: '30px',width: '30px', backgroundColor: color[0], borderRadius: '50%', border: color[0] === selectedColor[0] ? '2px solid #000' : 'none'}} 
                        onClick={()=>{
                            setSelectedColor(color)
                        }} >
                        </Box>
                    })}
                </Box>
            </Grid>
            <Grid container xs={11} gap={3} height={'50%'}>
                <Grid container xs={12} >
                    <Grid item px={2} xs={3}>
                        <Card variant="outlined" onClick={()=>setSelectedTemplate(5)} sx={{border: selectedTemplate === 5 ? '2px solid #000' : 'none', height: '100%'}}>
                            <Preview4 fieldValues={data} selectedColor={selectedColor} page={'template'}fullHeight={true} sections={sections}/>
                        </Card>
                    </Grid>
                    <Grid item px={2} xs={3}>
                        <Card variant="outlined" onClick={()=>setSelectedTemplate(6)} sx={{border: selectedTemplate === 6 ? '2px solid #000' : 'none', height: '100%'}}>
                            <Preview5 fieldValues={data} selectedColor={selectedColor} page={'template'}fullHeight={true} sections={sections}/>
                        </Card>
                    </Grid>
                    <Grid item px={2} xs={3}>
                        <Card variant="outlined" onClick={()=>setSelectedTemplate(7)} sx={{border: selectedTemplate === 7 ? '2px solid #000' : 'none', height: '100%'}}>
                            <Preview6 fieldValues={data} selectedColor={selectedColor} page={'template'}fullHeight={true} sections={sections}/>
                        </Card>
                    </Grid>
                </Grid>
                <Grid container xs={12} >
                    <Grid item px={2} xs={3}>
                        <Card variant="outlined" onClick={()=>setSelectedTemplate(1)} sx={{border: selectedTemplate === 1 ? '2px solid #000' : 'none', height: '100%'}}>
                            <Preview fieldValues={data} selectedColor={selectedColor} page={'template'}fullHeight={true} sections={sections}/>
                        </Card>
                    </Grid>
                    <Grid item px={2} xs={3}>
                        <Card variant="outlined" onClick={()=>setSelectedTemplate(2)} sx={{border: selectedTemplate === 2 ? '2px solid #000' : 'none', height:'100%'}}>
                            <Preview1 fieldValues={data} selectedColor={selectedColor} page={'template'} fullHeight={true} sections={sections}/>
                        </Card>
                    </Grid>
                    <Grid item px={2} xs={3}>
                        <Card variant="outlined" onClick={()=>setSelectedTemplate(3)} sx={{border: selectedTemplate === 3 ? '2px solid #000' : 'none', height:'100%'}}>
                            <Preview2 fieldValues={data} selectedColor={selectedColor} page={'template'} fullHeight={true} sections={sections}/>
                        </Card>
                    </Grid>
                    <Grid item px={2} xs={3}>
                        <Card variant="outlined" onClick={()=>setSelectedTemplate(4)} sx={{border: selectedTemplate === 4 ? '2px solid #000' : 'none', height:'100%'}}>
                            <Preview3 fieldValues={data} selectedColor={selectedColor} page={'template'} fullHeight={true} sections={sections}/>
                        </Card>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    </>
}
export default Template